import { environment } from '../../environments/environment';

export function isThirdPartyLoginUrl(backurl: string): boolean {
  const url = new URL(backurl);
  return (
    url.origin === environment.partnerReferrerUrl &&
    url.pathname === '/oauth/authorize'
  );
}
